/* eslint-disable react/prop-types */
import { Button, Col, Form, Input, message, Modal, Row, Select, Space, Spin, Switch, Table, Tag, Tooltip, Typography } from 'antd';
import React, { useEffect, useReducer, useState } from 'react';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import { useAuth } from '../../Context';
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { useFormik } from 'formik';
import axios from 'axios';
import wellGraphsReducer from './reducer';
import { WATERFALL_GRAPH_LIST_ERROR, WATERFALL_GRAPH_LIST_SUCCESS, WATERFALL_GRAPH_UPDATE_DATA, WATERFALL_GRAPH_LIST } from './constants';

// const { Title } = Typography;

export default function WaterfallCrud (props) {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	// const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);

	const initalState = { loading: false, error: false, waterfallData: [], updateData : {}, dasData : {} };
	const [data, dispatch] = useReducer(wellGraphsReducer, initalState);

	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`);

	const { getPids, pidsData , wellalgorithmdata, getWellAlgorithm, handleGetMapdata, mapdata } = useAuth();

	const [addModal, setAddModal] = useState(false);   
	const [editModal, setEditModal] = useState(false);       
	const [deleteModal, setDeleteModal] = useState(false);
	const [deleteId, setDeleteId] = useState();
	const [updateId, setUpdateId] = useState();

	const [suppressionValues, setSuppressionValues] = useState([{ Start: '', End: '' }]);	
	const [suppressionUpdateValues, setSuppressionUpdateValues] = useState([{ Start: '', End: '' }]);	

	useEffect(() => {
		setAddModal(props.modal);
	},[props.modal]);
    
	useEffect(() => {
		getPids(authtoken);
		getWellAlgorithm(authtoken);
		handleGetMapdata(authtoken);
	},[authtoken]);
	
	const pidsdatas =[];
	pidsData && pidsData.map((item) => {		
		pidsdatas.push({
			value : item.id,
			label : item.name.toUpperCase(),
		});
	});

	const algoritham = [];
	wellalgorithmdata && wellalgorithmdata.data.map((item) => {		
		algoritham.push({
			value : item.id,
			label : item.name
		});
	});

	const trueAndFalse = [
		{value: true, label: langdata && langdata.Yes ? langdata.Yes : 'Yes'},
		{value: false, label: langdata && langdata.No ? langdata.No : 'No'}
	];

	let pipelineChainage = [];
	
	mapdata &&  mapdata.map((item)=>{

		pipelineChainage.push({
			value:item.pipelineChainage,
			label:item.pipelineChainage.toString()
		});
	});	
	
	const columns = [
		{
			title: langdata && langdata.PIDSName ? langdata.PIDSName : 'PIDS Name',
			dataIndex: 'pidsinfoId',
			key: 'pidsinfoId',
			render: (_, record) => (
				<Space>
					{
						(pidsData && pidsData.find((pid) => pid.id == record.pidsinfoId).name.toUpperCase())
					}
				</Space>
			)
		},
		{
			title: langdata && langdata.Algorithm ? langdata.Algorithm : 'Algorithm',
			dataIndex: 'algorithmId',
			key: 'algorithmId',
			render: (_, record) => (
				<Space>
					{
						(wellalgorithmdata && wellalgorithmdata.data && wellalgorithmdata.data.find((algorithmId) => algorithmId.id == record.algorithmId).name.toUpperCase())
					}
				</Space>
			)
		},
		{
			title: langdata && langdata.DeviceName ? langdata.DeviceName : 'Device Name',
			dataIndex: 'deviceName',
			key: 'deviceName',			
		},
		{
			title: langdata && langdata.Directory ? langdata.Directory : 'Directory',
			dataIndex: 'directory',
			key: 'directory',			
		},
		{
			title: langdata && langdata.FileName ? langdata.FileName : 'File Name',
			dataIndex: 'fileName',
			key: 'fileName',			
		},
		{
			title: langdata && langdata.LoggingStatus ? langdata.LoggingStatus : 'Logging Status',
			dataIndex: 'isLogging',
			key: 'isLogging',
			render: (record) => (				
				<Tag color={record.isLogging ? 'green' : 'red'}>
					{record.isLogging ? (langdata && langdata.Yes ? langdata.Yes : 'Yes') : (langdata && langdata.No ? langdata.No : 'No')}
				</Tag>
			)
		},
		// {
		// 	title: langdata && langdata.System ? langdata.System : 'System',
		// 	key: 'system',
		// 	render: (_, record) => (
		// 		<Space size="middle">
		// 			<Space style={{justifyContent:'',display:'flex'}} size="middle">
		// 				<>
		// 					<Button style={{ display : 'contents', color : '#1FA8FF'}} onClick={() => {handleDasData(record);}}>{langdata && langdata.DAS ? langdata.DAS:'DAS'}</Button>
		// 				| <Button style={{ display : 'contents', color : '#1FA8FF'}} onClick={() => {handleDtsData(record);}}>{langdata && langdata.DTS ? langdata.DTS:'DTS'}</Button>
		// 				| <Button style={{ display : 'contents', color : '#1FA8FF'}}  onClick={() => {handlePressureData(record);}}>{langdata && langdata.Pressure ? langdata.Pressure:'Pressure'}</Button>
		// 				</>
		// 			</Space>
		// 		</Space>
		// 	)
		// },
		{
			title: langdata && langdata.Actions ? langdata.Actions : 'Actions',
			key: 'action',
			render: (_,record) => (
				<Space size="middle">
					<a title={langdata && langdata.Edit ? langdata.Edit : 'Edit'} onClick={() => {handleEditData(record);}}><EditOutlined/></a> 
					{permission==='superadmin' ?
						<a title={langdata && langdata.Delete ? langdata.Delete : 'Delete'} onClick={() => {openDeleteModal(record);}} ><DeleteOutlined /></a>
						: null }
				</Space>
			)
		}
	];

	// const handleDasData = (value) => {
	// 	setDasModal(true);
	// 	dispatch({ type : WATERFALL_GRAPH_UPDATE_DATA , payload : value});
	// 	setUpdateId(value.id);
	// };

	// const handleDtsData = (value) => {
	// 	setDtsModal(true);
	// 	dispatch({ type : WATERFALL_GRAPH_UPDATE_DATA , payload : value});
	// 	setUpdateId(value.id);
	// };

	// const handlePressureData = (value) => {
	// 	setPressureModal(true);
	// 	dispatch({ type : WATERFALL_GRAPH_UPDATE_DATA , payload : value});
	// 	setUpdateId(value.id);
	// };

	useEffect(() => {
		loadSandingress();
	},[]);
	
	const openDeleteModal = (value) => {
		setDeleteId(value.id);
		setDeleteModal(true);
	};

	const loadSandingress = () => {
		dispatch({ type : WATERFALL_GRAPH_LIST });
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/waterfallconfig`,
			timeout: timeout,
			headers: { 
				Authorization:`Bearer ${authtoken}`	
			}
		};

		axios.request(config)
			.then((response) => {
				if( response.status == 200) {					
					dispatch ({ type : WATERFALL_GRAPH_LIST_SUCCESS, payload : response.data.data });
				} else {
					dispatch({ type : WATERFALL_GRAPH_LIST_ERROR });
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : WATERFALL_GRAPH_LIST_ERROR });
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

	const handleEditData = (value) => {
		setUpdateId(value.id);
		dispatch({ type : WATERFALL_GRAPH_UPDATE_DATA, payload : value });
		setEditModal(true);
		const startArr =  editFormik?.values?.suppressions?.start || [];
		const endArr = editFormik?.values?.suppressions?.end || [];
		const result = startArr.map((startValue, idx) => ({
			Start: startValue,
			End: endArr[idx]
		}));
		setSuppressionUpdateValues(result);
	};
	

	const addFormik = useFormik({
		enableReinitialize: true,
		initialValues : {
			pidsinfoId : null,
			algorithmId : null,
			sampleRate : null,
			FPS : null,
			zoomDistance : null,
			minMagThresholds : null,
			maxMagThresholds : null,
			minAmpSNThresholds : null,
			maxAmpSNThresholds : null,
			minAmpFreqThresholds : null,
			maxAmpFreqThresholds : null,
			isLogging : null,
			deviceName : null,
			directory : null,
			fileName : null,
			suppressions : null,
			
		},
		onSubmit: (values) => {
			const {pidsinfoId, algorithmId, sampleRate, FPS, zoomDistance, minMagThresholds, maxMagThresholds, minAmpSNThresholds, 
				maxAmpSNThresholds, minAmpFreqThresholds, maxAmpFreqThresholds, isLogging, deviceName, directory, fileName} = values;

			if(pidsinfoId == null || algorithmId == null || sampleRate == null || FPS == null || zoomDistance == null || minMagThresholds == null || 
                    maxMagThresholds == null || minAmpSNThresholds == null || maxAmpSNThresholds == null || minAmpFreqThresholds == null || maxAmpFreqThresholds == null || 
                    isLogging == null || deviceName == null || directory == null || fileName == null ){
				Modal.warning({title : langdata && langdata.Pleasefillallthefields ? langdata.Pleasefillallthefields : 'Please fill all the fields'});
				return false;
			}

			if(!suppressionValues || suppressionValues.length > 0 && suppressionValues.some((input) => input.Start === '' || input.End === '')) {
				Modal.warning({title : langdata && langdata.Pleasefillallsuppressionfields ? langdata.Pleasefillallsuppressionfields : 'Please fill all suppression fields'});
				return false;
			}

			const start = [];
			const end = [];
			suppressionValues && suppressionValues.map((input) => {
				start.push(input.Start);
				end.push(input.End);
			});			

			let data = JSON.stringify({
				'pidsinfoId': pidsinfoId,
				'algorithmId': algorithmId,
				'sampleRate': sampleRate,
				'FPS': FPS,
				'zoomDistance': zoomDistance,
				'pipelineId': parseInt(pipelineId),
				'magThresholds': {
					'maxThreshold': maxMagThresholds,
					'minThreshold': minMagThresholds,
					'defaultmaxThreshold': 100,
					'defaultminThreshold': 10
				},
				'magThresholdsOverride': false,
				'ampFreqThresholds': {
					'maxThreshold': maxAmpFreqThresholds,
					'minThreshold': minAmpFreqThresholds,
					'defaultmaxThreshold': 100,
					'defaultminThreshold': 10
				},
				'ampFreqThresholdsOverride': false,
				'ampSNThresholds': {
					'maxThreshold': maxAmpSNThresholds,
					'minThreshold': minAmpSNThresholds,
					'defaultmaxThreshold': 100,
					'defaultminThreshold': 10
				},
				'ampSNThresholdsOverride': false,
				'deviceName': deviceName,
				'directory': directory,
				'fileName': fileName,
				'isLogging': isLogging,
				'suppressions': {
					'end': end,
					'start': start
				},
			});

			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/waterfallconfig`,
				timeout: timeout,
				headers: { 
					'Content-Type': 'application/json', 
					Authorization:`Bearer ${authtoken}`	
				},
				data : data
			};

			axios.request(config)
				.then((response) => {
					if(response.status == 200 || response.status == 201) {
						Modal.success({ title: langdata && langdata.Waterfalldetailssavedsuccessfully ? langdata.Waterfalldetailssavedsuccessfully : 'Waterfall details saved successfully.' });
						loadSandingress();
						setAddModal(false);
						props.setOpenModal(false);
						addFormik.resetForm();
					}else {
						Modal.warning({ title: langdata && langdata.Unabletosavewaterfalldetails ? langdata.Unabletosavewaterfalldetails : 'Unable to save waterfall details' });
					}					
				})
				.catch((error) => {
					console.log(error);
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					} else {
						Modal.warning({ title: langdata && langdata.Unabletosavewaterfalldetails ? langdata.Unabletosavewaterfalldetails : 'Unable to save waterfall details' });						
					}
				});
			addFormik.resetForm();
		}
	});		

	const editFormik = useFormik({
		enableReinitialize: true,
		initialValues : {
			pidsinfoId : data.updateData && data.updateData.pidsinfoId,
			algorithmId : data.updateData && data.updateData.algorithmId,
			sampleRate : data.updateData && data.updateData.sampleRate,
			FPS : data.updateData && data.updateData.FPS,
			zoomDistance : data.updateData && data.updateData.zoomDistance,
			minMagThresholds : data.updateData && data.updateData.magThresholds && data.updateData.magThresholds.minThreshold,
			maxMagThresholds : data.updateData && data.updateData.magThresholds && data.updateData.magThresholds.maxThreshold,
			minAmpSNThresholds : data.updateData && data.updateData.ampSNThresholds && data.updateData.ampSNThresholds.minThreshold,
			maxAmpSNThresholds : data.updateData && data.updateData.ampSNThresholds && data.updateData.ampSNThresholds.maxThreshold,
			minAmpFreqThresholds : data.updateData && data.updateData.ampFreqThresholds && data.updateData.ampFreqThresholds.minThreshold,
			maxAmpFreqThresholds : data.updateData && data.updateData.ampFreqThresholds && data.updateData.ampFreqThresholds.maxThreshold,
			magThresholdsOverride : data.updateData && data.updateData.magThresholdsOverride,
			ampFreqThresholdsOverride : data.updateData && data.updateData.ampFreqThresholdsOverride,
			ampSNThresholdsOverride : data.updateData && data.updateData.ampSNThresholdsOverride,
			isLogging : data.updateData && data.updateData.isLogging,
			deviceName : data.updateData && data.updateData.deviceName,
			directory : data.updateData && data.updateData.directory,
			fileName : data.updateData && data.updateData.fileName,
			suppressions : data.updateData && data.updateData.suppressions ? data.updateData.suppressions : null,
		},
		onSubmit: (values) => {
			const {pidsinfoId, algorithmId, sampleRate, FPS, zoomDistance, minMagThresholds, maxMagThresholds, minAmpSNThresholds, 
				maxAmpSNThresholds, minAmpFreqThresholds, maxAmpFreqThresholds, magThresholdsOverride, ampFreqThresholdsOverride, ampSNThresholdsOverride, isLogging, 
				deviceName, directory, fileName } = values;			
				
			if(pidsinfoId == null || algorithmId == null || sampleRate == null || FPS == null || zoomDistance == null || minMagThresholds == null || 
                    maxMagThresholds == null || minAmpSNThresholds == null || maxAmpSNThresholds == null || minAmpFreqThresholds == null || maxAmpFreqThresholds == null || 
                    isLogging == null || deviceName == null || directory == null || fileName == null ){
				Modal.warning({title : langdata && langdata.Pleasefillallthefields ? langdata.Pleasefillallthefields : 'Please fill all the fields'});
				return false;
			}

			if(!suppressionUpdateValues || suppressionUpdateValues.length > 0 && suppressionUpdateValues.some((input) => input.Start === '' || input.End === '')) {
				Modal.warning({title : langdata && langdata.Pleasefillallsuppressionfields ? langdata.Pleasefillallsuppressionfields : 'Please fill all suppression fields'});
				return false;
			}

			const start = [];
			const end = [];
			suppressionUpdateValues && suppressionUpdateValues.map((input) => {
				start.push(input.Start);
				end.push(input.End);
			});			

			let data = JSON.stringify({
				'pidsinfoId': pidsinfoId,
				'algorithmId': algorithmId,
				'sampleRate': sampleRate,
				'FPS': parseInt(FPS),
				'zoomDistance': parseInt(zoomDistance),
				'pipelineId': parseInt(pipelineId),
				'magThresholds': {
					'maxThreshold': maxMagThresholds,
					'minThreshold': minMagThresholds,
					'defaultmaxThreshold': 100,
					'defaultminThreshold': 10
				},
				'magThresholdsOverride': magThresholdsOverride,
				'ampFreqThresholds': {
					'maxThreshold': maxAmpFreqThresholds,
					'minThreshold': minAmpFreqThresholds,
					'defaultmaxThreshold': 100,
					'defaultminThreshold': 10
				},
				'ampFreqThresholdsOverride': ampFreqThresholdsOverride,
				'ampSNThresholds': {
					'maxThreshold': maxAmpSNThresholds,
					'minThreshold': minAmpSNThresholds,
					'defaultmaxThreshold': 100,
					'defaultminThreshold': 10
				},
				'ampSNThresholdsOverride': ampSNThresholdsOverride,
				'deviceName': deviceName,
				'directory': directory,
				'fileName': fileName,
				'isLogging': isLogging,
				'suppressions': {
					'end': end,
					'start': start
				},
			});

			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/waterfallconfig/${updateId}`,
				timeout: timeout,
				headers: { 
					'Content-Type': 'application/json', 
					Authorization:`Bearer ${authtoken}`	
				},
				data : data
			};

			axios.request(config)
				.then((response) => {
					if(response.status == 200 || response.status == 201) {
						loadSandingress();
						Modal.success({ title: langdata && langdata.Waterfalldetailssuccessfullyupdated ? langdata.Waterfalldetailssuccessfullyupdated : 'Waterfall details successfully updated.' });
						setEditModal(false);
						// setDasModal(false);
						// setDtsModal(false);
						// setPressureModal(false);
						dispatch({ type : WATERFALL_GRAPH_UPDATE_DATA, payload : null });
					} else {
						Modal.warning({ title: langdata && langdata.Unabletoupdatewaterfalldetails ? langdata.Unabletoupdatewaterfalldetails : 'Unable to update waterfall details' });

					}
				})
				.catch((error) => {
					console.log(error);
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					} else {
						Modal.warning({ title: langdata && langdata.Unabletoupdatewaterfalldetails ? langdata.Unabletoupdatewaterfalldetails : 'Unable to update waterfall details' });
					}
				});
			editFormik.resetForm();
		}
	});		

		
	useEffect(() => {
		const startArr =  editFormik?.values?.suppressions?.start || [];
		const endArr = editFormik?.values?.suppressions?.end || [];
		const result = startArr.map((startValue, idx) => ({
			Start: startValue,
			End: endArr[idx]
		}));
		setSuppressionUpdateValues(result);
	},[editFormik?.values?.suppressions]);
		

	const handleDelete = () => {

		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/waterfallconfig/${deleteId}`,
			timeout: timeout,
			headers: { 
				Authorization:`Bearer ${authtoken}`
			}
		};
		
		axios.request(config)
			.then((response) => {
				if(response.status == 200 || response.status == 201) {
					Modal.success({ title: langdata && langdata.Waterfalldetailssuccessfullydeleted ? langdata.Waterfalldetailssuccessfullydeleted : 'Waterfall details successfully deleted.' });
					loadSandingress();		
				} else {
					Modal.warning({ title: langdata && langdata.Unabletodeletewaterfalldetails ? langdata.Unabletodeletewaterfalldetails : 'Unable to delete waterfall details' });
				}
			})
			.catch((error) => {
				console.log(error);
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				} else {
					Modal.warning({ title: langdata && langdata.Unabletodeletewaterfalldetails ? langdata.Unabletodeletewaterfalldetails : 'Unable to delete waterfall details' });
				}
			});
		setDeleteModal(false);
	};

	const handleOk = () => {
		setAddModal(false);
		props.setOpenModal(false);
		setEditModal(false);
		setDeleteModal(false);
		// setDasModal(false);
		// setDtsModal(false);
		// setPressureModal(false);
		editFormik.resetForm();
		addFormik.resetForm();
	};
	const handleCancel = () => {
		setAddModal(false);
		props.setOpenModal(false);
		setEditModal(false);
		setDeleteModal(false);
		// setDasModal(false);
		// setDtsModal(false);
		// setPressureModal(false);
		editFormik.resetForm();
		addFormik.resetForm();
		setSuppressionValues([{ Start: '', End: '' }]);
		setSuppressionUpdateValues([{ Start: '', End: '' }]);
	};

	const handleChangeSuppression = (index, field, value) => {
		const newSuppressionValues = [...suppressionValues];
		newSuppressionValues[index][field] = value;
		setSuppressionValues(newSuppressionValues);
	};

	const handleAddSuppression = () => {
		setSuppressionValues([...suppressionValues, { Start: '', End: '' }]);
	};

	const handleDeleteSuppression = (index) => {
		setSuppressionValues(suppressionValues.filter((_, i) => i !== index));
	};

	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());

	const handleUpdateChangeSuppression = (index, field, value) => {
		const newSuppressionValues = [...suppressionUpdateValues];
		newSuppressionValues[index][field] = value;
		setSuppressionUpdateValues(newSuppressionValues);
	};

	const handleUpdateAddSuppression = () => {
		setSuppressionUpdateValues([...suppressionUpdateValues, { Start: '', End: '' }]);
	};

	const handleUpdateDeleteSuppression = (index) => {
		setSuppressionUpdateValues(suppressionUpdateValues.filter((_, i) => i !== index));
	};

	return (
		<>			
			<Row span={24} style={{
				margin: '10px',
				paddingLeft: '10px',
				paddingRight: '10px',
				background: '#FFFFFF',
				alignItems:'center'
			}} >
				<Col span={24}>
					<Table
						scroll={{
							x: 900,
						}}
						columns = { columns } 
						dataSource = { data.waterfallData } 
					/>

				</Col>
			</Row>
			<Modal
				title={langdata && langdata.AddWaterfall ? langdata.AddWaterfall : 'Add Waterfall'}
				centered
				open={addModal}
				onOk={handleOk}
				onCancel={handleCancel}
				maskClosable={false}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={handleCancel}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE'}</Button>
						<Button type="primary"  onClick={addFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE'}</Button>
					</Space>
				]}
				width={800}
			>
				<Form layout="vertical" >
					<Row gutter={24}>
						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.PidsName ? langdata.PidsName : 'Pids Name'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseselectthepidsname ? langdata.Pleaseselectthepidsname : 'Please select the pids name' }]} required>
								<Select
									style={{ minWidth: '200px', margin:'5px'}}
									showSearch
									// filterOption={filterOption}
									placeholder={ langdata && langdata.Pleaseselectthepid ? langdata.Pleaseselectthepid : 'Please select the pid' }
									optionFilterProp="children"
									options={pidsdatas}
									onChange={(value) => addFormik.setFieldValue('pidsinfoId', value)}
									// onSelect={handleWellInfo}
									// value={wellInfoId}
								/>
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.Algoritham ? langdata.Algoritham : 'Algoritham'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseselectthealgoritham ? langdata.Pleaseselectthealgoritham : 'Please select the algoritham' }]} required>
								<Select
									style={{ minWidth: '200px', margin:'5px'}}
									showSearch
									// filterOption={filterOption}
									placeholder={ langdata && langdata.Pleaseselectthealgoritham ? langdata.Pleaseselectthealgoritham : 'Please select the algoritham' }
									optionFilterProp="children"
									options={algoritham}
									onChange={(value) => addFormik.setFieldValue('algorithmId', value)}
									// onSelect={handleWellInfo}
									// value={wellInfoId}
								/>
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.SampleRate ? langdata.SampleRate : 'Sample Rate'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthesamplerate ? langdata.Pleaseenterthesamplerate : 'Please enter the sample rate' }]} required>
								<Input 
									name="sampleRate" 
									type='number'
									onWheel={(e) => e.target.blur()}
									placeholder={langdata && langdata.Pleaseenterthesamplerate ? langdata.Pleaseenterthesamplerate : 'Please enter the sample rate'}
									onChange={(e) => {e.target.value < 10000 ? addFormik.setFieldValue('sampleRate', e.target.value) : '';}}
									value={addFormik.values.sampleRate}
									min={0}
								/>
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.FPS ? langdata.FPS : 'FPS'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthesamplerate ? langdata.Pleaseenterthesamplerate : 'Please enter the frames per second' }]} required>
								<Input 
									name="FPS" 
									type='number'
									onWheel={(e) => e.target.blur()}
									placeholder={langdata && langdata.Pleaseentertheframespersecond ? langdata.Pleaseentertheframespersecond : 'Please enter the frames per second'}
									// onChange={addFormik.handleChange} 
									onChange={(e) => {e.target.value < 240 ? addFormik.setFieldValue('FPS', e.target.value) : '';}}
									value={addFormik.values.FPS}
									min={0}
									max={240}
								/>
							</Form.Item>
						</Col>
					</Row>					
					<Row gutter={24}>
						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.MinimumMagnitudeThreshold ? langdata.MinimumMagnitudeThreshold : 'Minimum Magnitude Threshold'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseentertheminimummagnitudethreshold ? langdata.Pleaseentertheminimummagnitudethreshold : 'Please enter the minimum magnitude threshold' }]} required>
								<Input 
									name="minMagThresholds" 
									type='number'
									onWheel={(e) => e.target.blur()}
									placeholder={langdata && langdata.Pleaseentertheminimummagnitudethreshold ? langdata.Pleaseentertheminimummagnitudethreshold : 'Please enter the minimum magnitude threshold'}
									onChange={addFormik.handleChange} 
									value={addFormik.values.minMagThresholds}
									min={0}
								/>
							</Form.Item>
						</Col>
		
						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.MaximumMagnitudeThreshold ? langdata.MaximumMagnitudeThreshold : 'Maximum Magnitude Threshold'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthemaximummagnitudethreshold ? langdata.Pleaseenterthemaximummagnitudethreshold : 'Please enter the maximum magnitude threshold' }]} required>
								<Input 
									name="maxMagThresholds" 
									type='number'
									onWheel={(e) => e.target.blur()}
									placeholder={langdata && langdata.Pleaseenterthemaximummagnitudethreshold ? langdata.Pleaseenterthemaximummagnitudethreshold : 'Please enter the maximum magnitude threshold'}
									onChange={addFormik.handleChange} 
									value={addFormik.values.maxMagThresholds}
									min={0}
								/>
							</Form.Item>
						</Col>
						
						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.SNRatioMinimumThreshold ? langdata.SNRatioMinimumThreshold : 'S/N Ratio Minimum Threshold'} 
								rules={[{ required: true, message: langdata && langdata.PleaseentertheSNRatiominimumthreshold ? langdata.PleaseentertheSNRatiominimumthreshold : 'Please enter the S/N Ratio minimum threshold' }]} required>
								<Input 
									name="minAmpSNThresholds" 
									type='number'
									onWheel={(e) => e.target.blur()}
									placeholder={langdata && langdata.PleaseentertheSNRatiominimumthreshold ? langdata.PleaseentertheSNRatiominimumthreshold : 'Please enter the S/N Ratio minimum threshold'}
									onChange={addFormik.handleChange} 
									value={addFormik.values.minAmpSNThresholds}
									min={0}
								/>
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.SNRatioMaximumThreshold ? langdata.SNRatioMaximumThreshold : 'S/N Ratio Maximum Threshold'} 
								rules={[{ required: true, message: langdata && langdata.PleaseentertheSNRatiomaximumthreshold ? langdata.PleaseentertheSNRatiomaximumthreshold : 'Please enter the S/N Ratio  maximum threshold' }]} required>
								<Input 
									name="maxAmpSNThresholds" 
									type='number'
									onWheel={(e) => e.target.blur()}
									placeholder={langdata && langdata.PleaseentertheSNRatiomaximumthreshold ? langdata.PleaseentertheSNRatiomaximumthreshold : 'Please enter the maximum amplitude threshold'}
									onChange={addFormik.handleChange} 
									value={addFormik.values.maxAmpSNThresholds}
									min={0}
								/>
							</Form.Item>
						</Col>
						
						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.FrequencyLowerLimit ? langdata.FrequencyLowerLimit : 'Frequency Lower Limit'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthefrequencylowerlimit ? langdata.Pleaseenterthefrequencylowerlimit : 'Please enter the frequency lower limit' }]} required>
								<Input 
									name="minAmpFreqThresholds" 
									type='number'
									onWheel={(e) => e.target.blur()}
									placeholder={langdata && langdata.Pleaseenterthefrequencylowerlimit ? langdata.Pleaseenterthefrequencylowerlimit : 'Please enter the frequency lower limit'}
									onChange={addFormik.handleChange} 
									value={addFormik.values.minAmpFreqThresholds}
									min={0}
								/>
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.FrequencyUpperLimit ? langdata.FrequencyUpperLimit : 'Frequency Upper Limit'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthefrequencyupperlimit ? langdata.Pleaseenterthefrequencyupperlimit : 'Please enter the frequency upper limit' }]} required>
								<Input 
									name="maxAmpFreqThresholds" 
									type='number'
									onWheel={(e) => e.target.blur()}
									placeholder={langdata && langdata.Pleaseenterthefrequencyupperlimit ? langdata.Pleaseenterthefrequencyupperlimit : 'Please enter the frequency upper limit'}
									onChange={addFormik.handleChange} 
									value={addFormik.values.maxAmpFreqThresholds}
									min={0}
								/>
							</Form.Item>
						</Col>	

						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.ZoomDistance ? langdata.ZoomDistance : 'Zoom Distance'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthezoomdistance ? langdata.Pleaseenterthezoomdistance : 'Please enter the zoom distance' }]} required>
								<Input 
									name="zoomDistance" 
									type='number'
									placeholder={langdata && langdata.Pleaseenterthezoomdistance ? langdata.Pleaseenterthezoomdistance : 'Please enter the zoom distance'}
									// onChange={addFormik.handleChange} 
									onChange={(e) => {e.target.value < 1000 ? addFormik.setFieldValue('zoomDistance', e.target.value) : '';}}
									value={addFormik.values.zoomDistance}
								/>
							</Form.Item>
						</Col>

						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.LoggingStatus ? langdata.LoggingStatus : 'Logging Status'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseselectloggingstatus ? langdata.Pleaseselectloggingstatus : 'Please select logging status' }]} required>
								<Select
									style={{ minWidth: '200px', margin:'5px'}}
									showSearch
									// filterOption={filterOption}
									placeholder={ langdata && langdata.Pleaseselectloggingstatus ? langdata.Pleaseselectloggingstatus : 'Please select logging status' }
									optionFilterProp="children"
									options={trueAndFalse}
									onChange={(value) => addFormik.setFieldValue('isLogging', value)}
								/>
							</Form.Item>
						</Col>

						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.DeviceName ? langdata.DeviceName : 'Device Name'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthedevicename ? langdata.Pleaseenterthedevicename : 'Please enter the device name' }]} required>
								<Input 
									name="deviceName" 
									placeholder={langdata && langdata.Pleaseenterthedevicename ? langdata.Pleaseenterthedevicename : 'Please enter the device name'}
									onChange={addFormik.handleChange} 
									value={addFormik.values.deviceName}
								/>
							</Form.Item>
						</Col>

						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.Directory ? langdata.Directory : 'Directory'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthedirectory ? langdata.Pleaseenterthedirectory : 'Please enter the directory' }]} required>
								<Input 
									name="directory" 
									placeholder={langdata && langdata.Pleaseenterthedirectory ? langdata.Pleaseenterthedirectory : 'Please enter the directory'}
									onChange={addFormik.handleChange} 
									value={addFormik.values.directory}
								/>
							</Form.Item>
						</Col>

						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.FileName ? langdata.FileName : 'File Name'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterfilename ? langdata.Pleaseenterfilename : 'Please enter file name' }]} required>
								<Input 
									name="fileName" 
									placeholder={langdata && langdata.Pleaseenterfilename ? langdata.Pleaseenterfilename : 'Please enter the file name'}
									onChange={addFormik.handleChange} 
									value={addFormik.values.fileName}
								/>
							</Form.Item>
						</Col>
											
					</Row>
					<Row gutter={24}>
						<Col span={12}>
							<Typography strong style={{fontSize:'16px', color:'grey'}}><b>&#9658; {langdata && langdata.Suppressions ? langdata.Suppressions:'Suppressions'}</b></Typography>
						</Col>
						<Col span={12} justifyContent="end" style={{display:'flex', justifyContent:'flex-end'}}>
							<Button
								style={{margin:'5px'}} 
								type="primary" 
								icon={<PlusOutlined />}
								onClick={handleAddSuppression}
							/>
						</Col>
					</Row>
					{/* <Divider/> */}
					{suppressionValues.map((input, index) => (						
						<Row gutter={24} key={index}>
							<Col span={11}>
								<Form.Item
									label={langdata?.StartChainage || 'Start Chainage'}
									
								>
									{/* <Input
										placeholder={langdata?.Pleaseselectthestartchainage || 'Please select the start chainage'}
										value={input.Start}
										onChange={e => handleChangeSuppression(index, 'Start', e.target.value)}
									/> */}
									<Select
										style={{ minWidth: '200px', margin:'5px'}}
										showSearch
										filterOption={filterOption}
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										optionFilterProp="children"
										options={pipelineChainage}
										allowClear
										// value={input.Start}
										onChange={e => handleChangeSuppression(index, 'Start', e)}
									/>
								</Form.Item>
							</Col>
							<Col span={11}>
								<Form.Item
									label={langdata?.EndChainage || 'End Chainage'}
									
								>
									{/* <Input
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										value={input.End}
										onChange={e => handleChangeSuppression(index, 'End', e.target.value)}
									/> */}
									<Select
										style={{ minWidth: '200px', margin:'5px'}}
										showSearch
										filterOption={filterOption}
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										optionFilterProp="children"
										options={pipelineChainage}
										allowClear
										// value={input.End}
										onChange={e => handleChangeSuppression(index, 'End', e)}
									/>
								</Form.Item>
							</Col>
							<Col span={2} style={{ marginTop: '30px', textAlign: 'center' }}>
								<Button
									danger
									icon={<DeleteOutlined />}
									onClick={() => handleDeleteSuppression(index)}
									disabled={suppressionValues.length === 0}
								/>
							</Col>
						</Row>
					))}
				</Form>
			</Modal>

			<Modal
				title={langdata && langdata.EditWaterfall ? langdata.EditWaterfall : 'Edit Waterfall'}
				centered
				open={editModal}
				onOk={handleOk}
				onCancel={handleCancel}
				maskClosable={false}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={handleCancel}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE'}</Button>
						<Button type="primary"  onClick={editFormik.handleSubmit}>{langdata && langdata.UPDATE ? langdata.UPDATE : 'UPDATE'}</Button>
					</Space>
				]}
				width={800}
			>
				<Form layout="vertical" >
					<Row gutter={24}>
						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.PidsName ? langdata.PidsName : 'Pids Name'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseselectthepidsname ? langdata.Pleaseselectthepidsname : 'Please select the pids name' }]} required>
								<Select
									style={{ minWidth: '200px', margin:'5px'}}
									showSearch
									// filterOption={filterOption}
									placeholder={ langdata && langdata.Pleaseselectthepid ? langdata.Pleaseselectthepid : 'Please select the pid' }
									optionFilterProp="children"
									options={pidsdatas}
									onChange={(value) => editFormik.setFieldValue('pidsinfoId', value)}
									// onSelect={handleWellInfo}
									value={editFormik.values.pidsinfoId}
								/>
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.Algoritham ? langdata.Algoritham : 'Algoritham'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseselectthealgoritham ? langdata.Pleaseselectthealgoritham : 'Please select the algoritham' }]} required>
								<Select
									style={{ minWidth: '200px', margin:'5px'}}
									showSearch
									// filterOption={filterOption}
									placeholder={ langdata && langdata.Pleaseselectthealgoritham ? langdata.Pleaseselectthealgoritham : 'Please select the algoritham' }
									optionFilterProp="children"
									options={algoritham}
									onChange={(value) => editFormik.setFieldValue('algorithmId', value)}
									value={editFormik.values.algorithmId}
									// onSelect={handleWellInfo}
									// value={wellInfoId}
								/>
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.SampleRate ? langdata.SampleRate : 'Sample Rate'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthesamplerate ? langdata.Pleaseenterthesamplerate : 'Please enter the sample rate' }]} required>
								<Input 
									name="sampleRate" 
									type='number'
									onWheel={(e) => e.target.blur()}
									placeholder={langdata && langdata.Pleaseenterthesamplerate ? langdata.Pleaseenterthesamplerate : 'Please enter the sample rate'}
									onChange={(e) => {e.target.value < 10000 ? editFormik.setFieldValue('sampleRate', e.target.value) : '';}}
									value={editFormik.values.sampleRate}
									min={0}
								/>
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.FPS ? langdata.FPS : 'FPS'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthesamplerate ? langdata.Pleaseenterthesamplerate : 'Please enter the frames per second' }]} required>
								<Input 
									name="FPS" 
									type='number'
									onWheel={(e) => e.target.blur()}
									placeholder={langdata && langdata.Pleaseentertheframespersecond ? langdata.Pleaseentertheframespersecond : 'Please enter the frames per second'}
									// onChange={editFormik.handleChange} 
									onChange={(e) => {e.target.value < 240 ? editFormik.setFieldValue('FPS', e.target.value) : '';}}
									value={editFormik.values.FPS}
									min={0}
									max={240}
								/>
							</Form.Item>
						</Col>
					</Row>					
					<Row gutter={24}>
						
						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.MinimumMagnitudeThreshold ? langdata.MinimumMagnitudeThreshold : 'Minimum Magnitude Threshold'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseentertheminimummagnitudethreshold ? langdata.Pleaseentertheminimummagnitudethreshold : 'Please enter the minimum magnitude threshold' }]} required>
								<Input 
									name="minMagThresholds" 
									type='number'
									onWheel={(e) => e.target.blur()}
									placeholder={langdata && langdata.Pleaseentertheminimummagnitudethreshold ? langdata.Pleaseentertheminimummagnitudethreshold : 'Please enter the minimum magnitude threshold'}
									onChange={editFormik.handleChange} 
									value={editFormik.values.minMagThresholds}
									min={0}
								/>
							</Form.Item>
						</Col>
		
						<Col span={11}>
							<Form.Item 
								label={langdata && langdata.MaximumMagnitudeThreshold ? langdata.MaximumMagnitudeThreshold : 'Maximum Magnitude Threshold'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthemaximummagnitudethreshold ? langdata.Pleaseenterthemaximummagnitudethreshold : 'Please enter the maximum magnitude threshold' }]} required>
								<Input 
									name="maxMagThresholds" 
									type='number'
									onWheel={(e) => e.target.blur()}
									placeholder={langdata && langdata.Pleaseenterthemaximummagnitudethreshold ? langdata.Pleaseenterthemaximummagnitudethreshold : 'Please enter the maximum magnitude threshold'}
									onChange={editFormik.handleChange} 
									value={editFormik.values.maxMagThresholds}
									min={0}
								/>
							</Form.Item>
						</Col>
						<Col span={1}>
							<Form.Item
								label={' '} >
								<Tooltip placement="bottom" title={langdata && langdata.Override ? langdata.Override : 'Override'}>
									<Switch size="small" onClick={(value) => {editFormik.setFieldValue('magThresholdsOverride', value);}} checked={editFormik.values.magThresholdsOverride} />
								</Tooltip>
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.SNRatioMinimumThreshold ? langdata.SNRatioMinimumThreshold : 'S/N Ratio Minimum Threshold'} 
								rules={[{ required: true, message: langdata && langdata.PleaseentertheSNRatiominimumthreshold ? langdata.PleaseentertheSNRatiominimumthreshold : 'Please enter the S/N Ratio minimum threshold' }]} required>
								<Input 
									name="minAmpSNThresholds" 
									type='number'
									onWheel={(e) => e.target.blur()}
									placeholder={langdata && langdata.PleaseentertheSNRatiominimumthreshold ? langdata.PleaseentertheSNRatiominimumthreshold : 'Please enter the S/N Ratio minimum threshold'}
									onChange={editFormik.handleChange} 
									value={editFormik.values.minAmpSNThresholds}
									min={0}
								/>
							</Form.Item>
						</Col>
						<Col span={11}>
							<Form.Item 
								label={langdata && langdata.SNRatioMaximumThreshold ? langdata.SNRatioMaximumThreshold : 'S/N Ratio Maximum Threshold'} 
								rules={[{ required: true, message: langdata && langdata.PleaseentertheSNRatiomaximumthreshold ? langdata.PleaseentertheSNRatiomaximumthreshold : 'Please enter the S/N Ratio  maximum threshold' }]} required>
								<Input 
									name="maxAmpSNThresholds" 
									type='number'
									onWheel={(e) => e.target.blur()}
									placeholder={langdata && langdata.PleaseentertheSNRatiomaximumthreshold ? langdata.PleaseentertheSNRatiomaximumthreshold : 'Please enter the maximum amplitude threshold'}
									onChange={editFormik.handleChange} 
									value={editFormik.values.maxAmpSNThresholds}
									min={0}
								/>
							</Form.Item>
						</Col>
						<Col span={1}>
							<Form.Item
								label={' '} >
								<Tooltip placement="bottom" title={langdata && langdata.Override ? langdata.Override : 'Override'}>
									<Switch size="small" onClick={(value) => {editFormik.setFieldValue('ampSNThresholdsOverride', value);}} checked={editFormik.values.ampSNThresholdsOverride} />
								</Tooltip>
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.FrequencyLowerLimit ? langdata.FrequencyLowerLimit : 'Frequency Lower Limit'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthefrequencylowerlimit ? langdata.Pleaseenterthefrequencylowerlimit : 'Please enter the frequency lower limit' }]} required>
								<Input 
									name="minAmpFreqThresholds" 
									type='number'
									onWheel={(e) => e.target.blur()}
									placeholder={langdata && langdata.Pleaseenterthefrequencylowerlimit ? langdata.Pleaseenterthefrequencylowerlimit : 'Please enter the frequency lower limit'}
									onChange={editFormik.handleChange} 
									value={editFormik.values.minAmpFreqThresholds}
									min={0}
								/>
							</Form.Item>
						</Col>
						<Col span={11}>
							<Form.Item 
								label={langdata && langdata.FrequencyUpperLimit ? langdata.FrequencyUpperLimit : 'Frequency Upper Limit'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthefrequencyupperlimit ? langdata.Pleaseenterthefrequencyupperlimit : 'Please enter the frequency upper limit' }]} required>
								<Input 
									name="maxAmpFreqThresholds" 
									type='number'
									onWheel={(e) => e.target.blur()}
									placeholder={langdata && langdata.Pleaseenterthefrequencyupperlimit ? langdata.Pleaseenterthefrequencyupperlimit : 'Please enter the frequency upper limit'}
									onChange={editFormik.handleChange} 
									value={editFormik.values.maxAmpFreqThresholds}
									min={0}
								/>
							</Form.Item>
						</Col>	
						<Col span={1}>
							<Form.Item
								label={' '} >
								<Tooltip placement="bottom" title={langdata && langdata.Override ? langdata.Override : 'Override'}>
									<Switch size="small" onClick={(value) => {editFormik.setFieldValue('ampFreqThresholdsOverride', value);}} checked={editFormik.values.ampFreqThresholdsOverride} />
								</Tooltip>
							</Form.Item>
						</Col>		
						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.ZoomDistance ? langdata.ZoomDistance : 'Zoom Distance'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthezoomdistance ? langdata.Pleaseenterthezoomdistance : 'Please enter the zoom distance' }]} required>
								<Input 
									name="zoomDistance" 
									type='number'
									placeholder={langdata && langdata.Pleaseenterthezoomdistance ? langdata.Pleaseenterthezoomdistance : 'Please enter the zoom distance'}
									// onChange={editFormik.handleChange} 
									onChange={(e) => {e.target.value < 1000 ? editFormik.setFieldValue('zoomDistance', e.target.value) : '';}}
									value={editFormik.values.zoomDistance}
								/>
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.LoggingStatus ? langdata.LoggingStatus : 'Logging Status'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseselectloggingstatus ? langdata.Pleaseselectloggingstatus : 'Please select logging status' }]} required>
								<Select
									style={{ minWidth: '200px', margin:'5px'}}
									showSearch
									// filterOption={filterOption}
									placeholder={ langdata && langdata.Pleaseselectloggingstatus ? langdata.Pleaseselectloggingstatus : 'Please select logging status' }
									optionFilterProp="children"
									options={trueAndFalse}
									onChange={(value) => editFormik.setFieldValue('isLogging', value)}
									value={editFormik.values.isLogging}
								/>
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.DeviceName ? langdata.DeviceName : 'Device Name'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthedevicename ? langdata.Pleaseenterthedevicename : 'Please enter the device name' }]} required>
								<Input 
									name="deviceName" 
									placeholder={langdata && langdata.Pleaseenterthedevicename ? langdata.Pleaseenterthedevicename : 'Please enter the device name'}
									onChange={editFormik.handleChange} 
									value={editFormik.values.deviceName}
								/>
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.Directory ? langdata.Directory : 'Directory'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthedirectory ? langdata.Pleaseenterthedirectory : 'Please enter the directory' }]} required>
								<Input 
									name="directory" 
									placeholder={langdata && langdata.Pleaseenterthedirectory ? langdata.Pleaseenterthedirectory : 'Please enter the directory'}
									onChange={editFormik.handleChange} 
									value={editFormik.values.directory}
								/>
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.FileName ? langdata.FileName : 'File Name'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterfilename ? langdata.Pleaseenterfilename : 'Please enter file name' }]} required>
								<Input 
									name="fileName" 
									placeholder={langdata && langdata.Pleaseenterfilename ? langdata.Pleaseenterfilename : 'Please enter the file name'}
									onChange={editFormik.handleChange} 
									value={editFormik.values.fileName}
								/>
							</Form.Item>
						</Col>	
					</Row>

					<Row gutter={24}>
						<Col span={12}>
							<Typography strong style={{fontSize:'16px', color:'grey'}}><b>&#9658; {langdata && langdata.Suppressions ? langdata.Suppressions:'Suppressions'}</b></Typography>
						</Col>
						<Col span={12} justifyContent="end" style={{display:'flex', justifyContent:'flex-end'}}>
							<Button
								style={{margin:'5px'}} 
								type="primary" 
								icon={<PlusOutlined />}
								onClick={handleUpdateAddSuppression}
							/>
						</Col>
					</Row>

					{suppressionUpdateValues.map((input, index) => (						
						
						<Row gutter={24} key={index}>
							<Col span={11}>
								<Form.Item
									label={langdata?.StartChainage || 'Start Chainage'}
									required
								>
									{/* <Input
										placeholder={langdata?.Pleaseselectthestartchainage || 'Please select the start chainage'}
										value={input.Start}
										onChange={e => handleChangeSuppression(index, 'Start', e.target.value)}
									/> */}
									<Select
										style={{ minWidth: '200px', margin:'5px'}}
										showSearch
										filterOption={filterOption}
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										optionFilterProp="children"
										options={pipelineChainage}
										allowClear
										value={input.Start || input.Start == 0 && input.Start !== '' ? input.Start : null}
										onChange={e => handleUpdateChangeSuppression(index, 'Start', e)}
									/>
								</Form.Item>
							</Col>
							<Col span={11}>
								<Form.Item
									label={langdata?.EndChainage || 'End Chainage'}
									required
								>
									{/* <Input
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										value={input.End}
										onChange={e => handleChangeSuppression(index, 'End', e.target.value)}
									/> */}
									<Select
										style={{ minWidth: '200px', margin:'5px'}}
										showSearch
										filterOption={filterOption}
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										optionFilterProp="children"
										options={pipelineChainage}
										allowClear
										value={input.End || input.End == 0  && input.Start !== '' ? input.End : null}
										onChange={e => handleUpdateChangeSuppression(index, 'End', e)}
									/>
								</Form.Item>
							</Col>
							<Col span={2} style={{ marginTop: '30px', textAlign: 'center' }}>
								<Button
									danger
									icon={<DeleteOutlined />}
									onClick={() => handleUpdateDeleteSuppression(index)}
									disabled={suppressionUpdateValues.length === 0}
								/>
							</Col>
						</Row>
					))}
				</Form>
			</Modal>


			<Modal title={langdata && langdata.Confirmdelete ? langdata.Confirmdelete : 'Confirm delete'} open={deleteModal} onOk={handleOk} onCancel={handleCancel}
				footer={[
				// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={handleCancel}>{langdata && langdata.CANCEL ? langdata.CANCEL : 'CANCEL'}</Button>
						<Button key="submit" type="primary" onClick={handleDelete}>{langdata && langdata.DELETE ? langdata.DELETE : 'DELETE'}</Button>
					</Space>
				]}>
				<Row style={{
					marginTop: '10px',
					marginBottom: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={1}>
						<DeleteOutlined  style={{ fontSize: '14px'}}/>
					</Col>
					<Col span={23}>{ langdata && langdata.Areyousureyouwanttodeletethiswaterfall ? langdata.Areyousureyouwanttodeletethiswaterfall :'Are you sure you want to delete this waterfall?'}</Col>
				</Row>
			</Modal>
			<Spin fullscreen spinning={data.loading} />
		</>
	);
}